'use client';

import React, { useEffect, useState } from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-ink/90 backdrop-blur-md border-b border-parchment/5' :'bg-transparent'
      }`}
    >
      <div className="max-w-8xl mx-auto px-8 md:px-14 h-16 flex items-center justify-between">
        <AppLogo
          text="Knxckout Media"
          size={28}
          className="font-serif text-parchment tracking-[0.22em] text-sm font-light cursor-pointer"
        />
        <nav className="hidden md:flex items-center gap-10">
          {['My Approach', 'Services', 'Portfolio']?.map((item) => {
            const hrefMap: Record<string, string> = {
              'My Approach': 'approach',
              'Services': 'services',
              'Portfolio': 'portfolio',
            };
            return (
              <a
                key={item}
                href={`#${hrefMap[item] ?? item?.toLowerCase()?.replace(/\s+/g, '-')}`}
                className="gold-link text-xs tracking-[0.12em] uppercase font-medium text-parchment/50 hover:text-gold transition-colors duration-300"
              >
                {item}
              </a>
            );
          })}
        </nav>
        <a
          href="https://ig.me/m/knxckout.media"
          target="_blank"
          rel="noopener noreferrer"
          className="gold-btn hidden md:inline-flex items-center"
        >
          <span>Book a Shoot</span>
        </a>
      </div>
    </header>
  );
}